import React from 'react';
import dayjs from 'dayjs';
import { useScreenSize } from '../../hooks/useScreenSize';
import { getReservationCalendar } from '../../api/setting/reservation-calendar';
import { CalendarGrid } from './grid';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { TCarCalendar } from '../start-work-order/type';

export const ReservationCalendarPage: React.FC = () => {
    const size = useScreenSize();
    const mobileMode = size === 'xs' || size === 'sm';
    const [currentMonth, setCurrentMonth] = React.useState(
        dayjs().startOf('month')
    );
    const [carData, setCarData] = React.useState<TCarCalendar[]>([]);
    const [loading, setLoading] = React.useState(false);

    const fetchCalendar = React.useCallback(async (month: dayjs.Dayjs) => {
        setLoading(true);
        try {
            const startDate = month.format('YYYY-MM-DD');
            const endDate = month.endOf('month').format('YYYY-MM-DD');
            const result = await getReservationCalendar(startDate, endDate);
            setCarData(result.data ?? []);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Failed to fetch calendar:', error);
        } finally {
            setLoading(false);
        }
    }, []);

    React.useEffect(() => {
        fetchCalendar(currentMonth);
    }, [currentMonth, fetchCalendar]);

    const prevMonth = () => setCurrentMonth(currentMonth.subtract(1, 'month'));
    const nextMonth = () => setCurrentMonth(currentMonth.add(1, 'month'));

    return (
        <div className="p-4">
            <div className="flex items-center justify-between mb-4">
                <Button icon={<LeftOutlined />} onClick={prevMonth} />
                <h2 className="text-lg font-semibold">
                    {currentMonth.format('MMMM YYYY')}
                </h2>
                <Button icon={<RightOutlined />} onClick={nextMonth} />
            </div>
            {loading ? (
                <div className="text-center py-8 text-gray-400">Loading...</div>
            ) : (
                <CalendarGrid
                    month={currentMonth}
                    carData={carData}
                    mobileMode={mobileMode}
                />
            )}
        </div>
    );
};
